import Const from 'constants';

const HittersOrder = {
    setHittersOrderFromStorage(order) {
        return (dispatch) => {
            dispatch(this.setHittersOrder(order, {countPlayers: false, saveToStorage: false}));
        };
    },
    
    setHittersOrder(order, options = {}) {
        return (dispatch) => {
            const {countPlayers = true, saveToStorage = true} = options;

            dispatch({
                type: Const.SET_HITTERS_ORDER,
                order: order,
            });

            dispatch({
                type: Const.EXCLUDE_PLAYERS_NOT_IN_ORDER_RANGE,
                order: order,
            });

            countPlayers && dispatch(this.setPlayersCounters());

            saveToStorage && dispatch(
                this.saveDataToStorage('hittersOrder', function (state) {
                    const {mlbFilters} = state.playersData;

                    return mlbFilters.order;
                }),
            );
        };
    },
};

export default HittersOrder;
